import React, { useContext } from "react";

import TodoItem from "./TodoItem";
import { TodosContext } from "../store/todos-context";
import classes from "./Todos.module.css";

// React.FC as a type definition makes it clear that the function
// acts as a functional component (FC)
// NOTE: Looks like children were removed from FC in React version 18
// so have to manually add them now
// ? makes the prop optional
const Todos: React.FC = () => {
  const todosCtx = useContext(TodosContext);

  return (
    <ul className={classes.todos}>
      {todosCtx.items.map((item) => (
        // We can still add special props like "key" w/o defining them
        <TodoItem
          key={item.id}
          text={item.text}
          // bind() pre-configures function for future execution
          // Parameters: what will "this" refer to, args that onRemoveTodo will receive
          onRemoveTodo={todosCtx.removeTodo.bind(null, item.id)}
        />
      ))}
    </ul>
  );
};

export default Todos;
